const root = "https://manage-library-api.onrender.com/user"

export default root 
